function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M108.6,55.6c-2.1-0.8-3.9,0.6-5.2,2.3c-6.3,8.5-16.1,14.8-21.9,16.2c-3.8,0.9-14.3,0.5-17.9-6.5 c-3.2-6.4-2.8-15.5,2.4-21c4.4-4.7,11.2-7.7,13.4-10c3.4-3.4,2.5-5,2.4-5.8c-0.5-2.2-3.4-2.3-5.6-2.5c-1.5-0.1-21.1-1.1-33.8,20.8 c-5.3,9.2-5.7,20.9-1.1,30.1c3.3,6.5,9.6,12.8,16.9,16.8v35.4c0,0.7,0.6,1.3,1.3,1.3h25.5c0.7,0,1.3-0.6,1.3-1.3V97.7 c15.3-6.7,22.5-23.7,24-34.8C110.7,60.7,110.7,56.4,108.6,55.6z"
});

var SvgSystemSetupIcon = function SvgSystemSetupIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    style: {
      enableBackground: "new 0 0 150 150"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSystemSetupIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/system-setup-icon.22860186.svg";
export { ForwardRef as ReactComponent };